import { Flex, Text, useTheme } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';
import { ReactComponent as MonsterOpenMouth } from 'assets/svgs/monster-open-mouth.svg';
import React, { FC } from 'react';
import { rem } from 'utils/fonts';

const Wrapper = styled(Flex)<{ inline?: boolean }>`
  flex-direction: ${(props): string => (props.inline ? 'row' : 'column')};
  align-items: flex-start;
  padding: ${(props): string => (props.inline ? '18px 20px' : '25px 20px')};
  position: relative;
  width: 100%;

  ::after {
    position: absolute;
    right: 0;
    top: 10px;
    bottom: 0;
    height: calc(100% - 20px);
    width: 3px;
    content: '';
    border-top-left-radius: 13px;
    border-bottom-left-radius: 13px;
  }
`;

const Title = styled(Text)`
  font-weight: bold;
  font-size: ${rem(14)};
  line-height: 135%;
`;

const SubTitle = styled(Text)`
  font-weight: normal;
  font-size: ${rem(13)};
  line-height: 135%;
`;

interface Props {
  title: string;
  subTitle: string;
  inline?: boolean;
}

const ComingSoon: FC<Props> = ({ title, subTitle, inline }) => {
  const { colors } = useTheme();
  return (
    <Wrapper
      inline={inline}
      border={`1px solid ${colors.other.CTA}`}
      bg="white"
      borderRadius="base"
      _after={{ bg: colors.other.CTA }}
      sx={{ '& path': { fill: colors.other.CTA } }}
      layerStyle="comingSoonWrapper"
    >
      <MonsterOpenMouth />
      <Flex direction="column" mt={inline ? '0' : '24px'} ml={inline ? '19px' : '0'}>
        <Title color="secondary.800">{title}</Title>
        <SubTitle mt="6px" color="secondary.800">
          {subTitle}
        </SubTitle>
      </Flex>
    </Wrapper>
  );
};

export default ComingSoon;
